// Stok Hareket Raporu kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.stockMovementsReport';

export const stockMovementsReportGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Stok Hareket Raporu nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu rapor, ürün bazında stok giriş-çıkış geçmişini tarih sırasıyla izlemeniz için hazırlanmıştır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    actions: t(`${G}.regions.actions`, 'Excel ve tablo ayarı'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Hareket listesi'),
    totals: t(`${G}.regions.totals`, 'Toplam satırı'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Kayıtları daraltın'),
      text: t(`${G}.s1.text`, '"Ara" ve "Ürün Ara" kutularıyla arama yapın. Filtre düğmesi İşlem Tipi, Kategori, Satış Ekranı ve başlangıç / bitiş tarihi-saati alanlarını açar; böylece sadece ihtiyacınız olan hareketleri listelersiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bir ürünün satırından "Hareket Raporu" ile geldiyseniz arama kutusu o ürünle dolu açılır.'),
        t(`${G}.s1.tip2`, '"Temizle" tüm arama ve filtreleri tek seferde sıfırlar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Satırları okuyun'),
      text: t(`${G}.s2.text`, 'Tablo satırlarında hareket yönünü (artış / azalış), miktar değişimini ve toplam tutarı birlikte görürsünüz. İşlem Tipi; satış, alım, fatura, sipariş, transfer, düzeltme ve üretim hareketlerini ayırt eder.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sütun başlığına tıklayarak sıralayabilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Hareket silme kuralları'),
      text: t(`${G}.s3.text`, 'Satırın sonundaki ⋮ düğmesinden hareket kaydını silebilirsiniz. Silme yalnız hareket kaydını siler; stok miktarları güncellenmez ve işlem geri alınamaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Fatura ile oluşmuş bir hareketi silmek için Fatura Yönetimi modülünden faturayı düzenleyin veya silin.'),
        t(`${G}.s3.tip2`, 'Üretim hareketleri buradan silinemez; "Fişi aç" ile üretim fişine gidip iptali oradan yapın.'),
      ],
    },
    {
      region: 'totals',
      title: t(`${G}.s4.title`, '4. Toplam satırı'),
      text: t(`${G}.s4.text`, 'Tablonun altındaki satır; toplam hareket sayısını, toplam miktar değişimini, satış adedini ve toplam tutarı gösterir.'),
    },
    {
      region: 'actions',
      title: t(`${G}.s5.title`, '5. Dışa aktarın, tabloyu düzenleyin'),
      text: t(`${G}.s5.text`, '"Excel İndir" ile mevcut filtre sonucunu dışa aktarabilir, "Tabloyu Özelleştir" ile raporu ihtiyacınıza göre düzenleyebilirsiniz. Satış Ekranı, Açıklama, Önceki miktar, Satış ve Fiyat gibi sütunlar başta gizlidir.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Kayıtlar sayfalar halinde gelir; sayfa başına 25, 50 veya 100 satır seçebilirsiniz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
